module.exports = "/wp-content/themes/aly-2-markkinointisaitti/static/images/quote-blue.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons/quote-blue.svg
// module id = 24
// module chunks = 2